import { render, staticRenderFns } from "./DealProducts.vue?vue&type=template&id=1600df04&"
import script from "./DealProducts.vue?vue&type=script&lang=ts&"
export * from "./DealProducts.vue?vue&type=script&lang=ts&"
import style0 from "./DealProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports